import React from "react";
import styles from "./style.module.css";
import MissionInfo from "../MissionInfo";

const MissionSection = () => {
  const missions = [
    {
      No: "01",
      Title: "2024 Founded",
      Desc: "Lorem ipsum dolor sit amet consectetur. Egestas duis faucibus vitae cras magna eget vitae scelerisque nunc. Pharetra in dictum amet eleifend lacus nulla orci. Sit tempor lorem suscipit bibendum diam.",
    },
    {
      No: "02",
      Title: "20k+ Downloads",
      Desc: "Lorem ipsum dolor sit amet consectetur. Egestas duis faucibus vitae cras magna eget vitae scelerisque nunc. Pharetra in dictum amet eleifend lacus nulla orci. Sit tempor lorem suscipit bibendum diam.",
    },
    {
      No: "03",
      Title: "15k+ Professionals",
      Desc: "Lorem ipsum dolor sit amet consectetur. Egestas duis faucibus vitae cras magna eget vitae scelerisque nunc. Pharetra in dictum amet eleifend lacus nulla orci. Sit tempor lorem suscipit bibendum diam.",
    },
  ];

  return (
    <div className={styles.sectionCotainer}>
      <div className={styles.textBox}>
        <h5>Our Mission</h5>
        <h2>Avasify Mission</h2>
        <p>
          Making property management easier and smarter, Avasify empowers
          success in real estate. We're committed to simplifying complexities
          and delivering unparalleled support.
        </p>
      </div>
      <div className={styles.mission}>
        {missions.map((info, index) => (
          <MissionInfo key={index} info={info} index={index} />
        ))}
      </div>
    </div>
  );
};

export default MissionSection;
